import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PromptUpdateService {

  
  displayAppUpdateDialogBox$ = new Subject<boolean>();

  constructor(private updates: SwUpdate) {

    updates.available.subscribe(event => {
        console.log("UPDATE!");
        this.displayAppUpdateDialogBox$.next(true);
    });
  }

  updateApp(){
    this.updates.activateUpdate().then(() => document.location.reload());

  }
}
